import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'

const Circulation = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={6}>
    <FormControl fullWidth>
      <InputLabel>Circulation</InputLabel>
      <Select
        value={moduleValues?.['Circulation'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Circulation']: e.target.value,
          }))
        }
        label="Circulation"
      >
        <MenuItem value="Central Pulse Present">Central Pulse Present</MenuItem>
        <MenuItem value="Peripheral Pulse Present">
          Peripheral Pulse Present
        </MenuItem>
        <MenuItem value="Obvious Signs of Life">Obvious signs of Life</MenuItem>
        <MenuItem value="No Pulse">No Pulse</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default Circulation
